import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';

const PaymentForm = ({ balance, onPayment, isProcessing }) => {
  const [amount, setAmount] = useState('');
  const [paymentMethod, setPaymentMethod] = useState('efectivo');
  const [change, setChange] = useState(0);

  const paymentMethods = [
    { value: 'efectivo', label: 'Efectivo' },
    { value: 'tarjeta', label: 'Tarjeta' },
    { value: 'transferencia', label: 'Transferencia' }
  ];

  const quickAmounts = [100, 200, 500, 1000];

  useEffect(() => {
    const numAmount = parseFloat(amount) || 0;
    if (paymentMethod === 'efectivo' && numAmount > balance) {
      setChange(numAmount - balance);
    } else {
      setChange(0);
    }
  }, [amount, balance, paymentMethod]);

  const handleQuickAmount = (value) => {
    setAmount(value?.toString());
  };

  const handlePayFull = () => {
    setAmount(balance?.toString());
  };

  const handleSubmit = () => {
    const numAmount = parseFloat(amount);
    if (numAmount > 0 && numAmount <= balance + (paymentMethod === 'efectivo' ? 100000 : 0)) {
      onPayment({
        amount: Math.min(numAmount, balance),
        method: paymentMethod,
        change: change
      });
      setAmount('');
      setChange(0);
    }
  };

  const isValidAmount = () => {
    const numAmount = parseFloat(amount);
    return numAmount > 0 && numAmount <= balance + (paymentMethod === 'efectivo' ? 100000 : 0);
  };

  return (
    <div className="bg-card rounded-xl shadow-elevation-2 p-4 md:p-6">
      <div className="flex items-center gap-2 mb-4 md:mb-6">
        <Icon name="DollarSign" size={24} color="var(--color-primary)" />
        <h3 className="text-lg md:text-xl font-semibold text-foreground">
          Procesar Pago
        </h3>
      </div>
      <div className="space-y-4 md:space-y-6">
        <div className="bg-primary/5 rounded-lg p-4">
          <p className="text-xs md:text-sm text-muted-foreground mb-1">Saldo Pendiente</p>
          <p className="text-2xl md:text-3xl lg:text-4xl font-bold text-primary">
            ${balance?.toLocaleString('es-ES', { minimumFractionDigits: 2 })}
          </p>
        </div>

        <div>
          <Select
            label="Método de Pago"
            options={paymentMethods}
            value={paymentMethod}
            onChange={setPaymentMethod}
            required
          />
        </div>

        <div>
          <Input
            label="Monto a Pagar"
            type="number"
            placeholder="0.00"
            value={amount}
            onChange={(e) => setAmount(e?.target?.value)}
            required
            min="0"
            step="0.01"
          />
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
          {quickAmounts?.map((value) => (
            <Button
              key={value}
              variant="outline"
              onClick={() => handleQuickAmount(value)}
              disabled={isProcessing}
              className="w-full"
            >
              ${value}
            </Button>
          ))}
        </div>

        <Button
          variant="secondary"
          iconName="CheckCircle"
          iconPosition="left"
          onClick={handlePayFull}
          disabled={isProcessing}
          fullWidth
        >
          Pagar Total
        </Button>

        {change > 0 && (
          <div className="bg-success/10 rounded-lg p-4">
            <p className="text-xs md:text-sm text-muted-foreground mb-1">Cambio</p>
            <p className="text-xl md:text-2xl font-bold text-success">
              ${change?.toLocaleString('es-ES', { minimumFractionDigits: 2 })}
            </p>
          </div>
        )}

        <Button
          variant="default"
          iconName="CreditCard"
          iconPosition="left"
          onClick={handleSubmit}
          loading={isProcessing}
          disabled={!isValidAmount()}
          fullWidth
          size="lg"
        >
          Procesar Pago
        </Button>
      </div>
    </div>
  );
};

export default PaymentForm;